import React from 'react';
import { formatMoney, isolateAmountLtr } from '../../../../utils/money';
import { formatSlipDateTime } from '../../../../utils/slip-date';
import reportClasses from '../reports/pos-report-view.module.scss';
import type { CashMoveDirection } from './CashMoveModal';

export type CashMoveSlipProps = {
  header: string;
  direction: CashMoveDirection;
  amount: number;
  reason: string;
  drawerName: string | null;
  employeeName: string | null;
  at: string;
  innerRef?: React.Ref<HTMLDivElement>;
};

// Summary: Printable cash in/out slip (Odoo CashMoveReceipt parity) on the shared report paper.
export const CashMoveSlip: React.FC<CashMoveSlipProps> = ({
  header, direction, amount, reason, drawerName, employeeName, at, innerRef,
}) => (
  <div ref={innerRef} className={`${reportClasses.paper} ${reportClasses.paperPrint}`} data-testid="cash-move-slip">
    <div className={reportClasses.header}>
      {header.split('\n').map((line, index) => (
        <span key={index} className={reportClasses.businessLine}>{line}</span>
      ))}
    </div>

    <div className={reportClasses.title}>{direction === 'out' ? 'מזומן יוצא' : 'מזומן נכנס'}</div>

    <div className={reportClasses.metaBlock}>
      <div className={reportClasses.metaRow}>תאריך: {formatSlipDateTime(at)}</div>
      <div className={reportClasses.metaRow}>מגירה: {drawerName ?? 'ללא מגירה'}</div>
      <div className={reportClasses.metaRow}>בוצע ע"י: {employeeName ?? '--'}</div>
    </div>

    <div className={reportClasses.section}>
      <div className={`${reportClasses.row} ${reportClasses.rowBold}`} data-testid="cash-move-slip-amount">
        <span className={reportClasses.rowLabel}>סכום</span>
        <span className={reportClasses.rowValue}>{isolateAmountLtr(formatMoney(direction === 'out' ? -amount : amount))} ₪</span>
      </div>
      <div className={reportClasses.row} data-testid="cash-move-slip-reason">
        <span className={reportClasses.rowLabel}>סיבה</span>
        <span className={reportClasses.rowValue}>{reason}</span>
      </div>
    </div>

    <div className={reportClasses.footer}>
      <div className={reportClasses.footerStars}>* * * * *</div>
    </div>

    <div className={reportClasses.poweredBy}>Powered by CommunicateAI</div>
  </div>
);
